<template>
  <div
    class="containerGeneral"
    :class="{ 'search-collapsed': isSearchCollapsed }"
  >
    <div class="containerConsultation">
      <div class="consultation-content">
        <span
          style="
            color: #344d67;
            font-size: 17px;
            border-bottom: 2px solid #0bc06f;
          "
          >Consulta de Agrotóxicos</span
        >
        <div class="searchForm">
          <div class="input-container">
            <label for="name" class="name">Nome / N° Registro</label>
            <input type="text" class="input" v-model="commonNameSearch" />
            <div class="underline"></div>
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            margin-top: 2rem;
            background: #eee;
            padding: 1rem;
            border-radius: 5px;
            justify-content: center;
            align-items: center;
            height: 50vh;
          "
          v-if="loadingPesticides"
        >
          <div class="loading-text">WINFIT</div>
          <div style="display: flex; gap: 10px">
            <b-spinner
              style="width: 20px; height: 20px; color: #006256"
            ></b-spinner>
            <span style="font-weight: 100; font-size: 16px; color: #006256"
              >Carregando ...</span
            >
          </div>
        </div>
        <div class="contentCards" v-else>
          <div
            class="productCard"
            v-for="pesticide in pesticideResults.data"
            :key="pesticide.id"
            :style="{ '--card-color': getCardColor(pesticide) }"
            @click="selectPesticide(pesticide)"
          >
            <div class="cardHeader">
              <div class="barsIcon">
                <span></span><span></span><span></span><span></span
                ><span></span>
              </div>
              <span class="productTitle">{{ pesticide.nomeComum }}</span>
            </div>
            <span class="registerTitle">n° {{ pesticide.registro }}</span>
            <div class="cardBody" style="display: none">
              <div class="info">
                <div class="label">Tipo de Produto</div>
                <div class="value">
                  {{ pesticide.formulacao?.nome || "Não informado" }}
                </div>
              </div>
              <div class="info">
                <div class="label">Substância Ativa</div>
                <div class="value">
                  {{ pesticide.ingredienteAtivo?.nomeComum || "Não informado" }}
                </div>
              </div>
              <div class="info cultures">
                <div class="label">Fabricante</div>
                <div class="value">
                  {{ pesticide.empresa?.razaoSocial || "Não informado" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="contentGeneral">
      <div
        class="collapse-toggle"
        @click="isSearchCollapsed = !isSearchCollapsed"
      >
        <span class="arrow">{{ isSearchCollapsed ? "›" : "‹" }}</span>
      </div>
      <div>
        <div v-if="selectedTabData">
          <div class="carroselCtn">
            <div class="StatementOnAccount">
              <label
                v-for="item in tabs"
                :key="item.text"
                class="StatementOnAccountItem"
                :class="{ active: selectedLabel === item.value }"
                @click="storeLabelName(item.text)"
              >
                {{ item.text }} <br />
              </label>
            </div>
          </div>
          <div
            class="content-pesticides"
            v-if="selectedLabel === 'Informações Gerais'"
          >
            <h2
              :style="{
                'border-top-color': getCardColor(this.selectedTabData),
              }"
            >
              {{ this.selectedTabData.nomeComum }}
            </h2>
            <div class="title-pesticides">
              <span
                >Registrado no Ministério da Agricultura, Pecuária e
                Abastecimento - MAPA sob n°{{
                  this.selectedTabData.registro || "Não informado"
                }}</span
              >
              <span
                >TITULAR DO REGISTRO:
                {{
                  this.selectedTabData.empresa?.razaoSocial || "Não informado"
                }}</span
              >
              <span style="font-size: 12px"
                >Última revisão em
                {{
                  this.selectedTabData.dataAtualizacao
                    .split("T")[0]
                    .split("-")
                    .reverse()
                    .join("/") || "N/A"
                }}</span
              >
            </div>
            <div class="container-info-pesticides">
              <div class="content-info-pesticides">
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides"
                    >Ingredientes ativos</span
                  >
                  <span>{{
                    this.selectedTabData.ingredienteAtivo?.nomeComum ||
                    "Não informado"
                  }}</span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides"
                    >Grupos químicos</span
                  >
                  <span>{{
                    this.selectedTabData.ingredienteAtivo?.grupoQuimico?.nome ||
                    "Não informado"
                  }}</span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides"
                    >Classes de ação</span
                  >
                  <span>{{
                    this.selectedTabData.classe?.nome || "Não informado"
                  }}</span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides"
                    >Classe toxicológica</span
                  >
                  <span>
                    {{ this.selectedTabData.classeToxicologica.classificacao }}
                    -
                    {{ this.selectedTabData.classeToxicologica?.nome }}
                  </span>
                </div>
              </div>
              <div class="content-info-pesticides">
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides">Concentração</span>
                  <span>
                    {{ this.selectedTabData.concentracaoIa }}
                    {{ this.selectedTabData.unidadeMedida }}
                  </span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides">Formulação</span>
                  <span>{{
                    this.selectedTabData.formulacao?.nome || "Não informado"
                  }}</span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides">Modos de ação</span>
                  <span>{{
                    this.selectedTabData.phIdeal || "Não informado"
                  }}</span>
                </div>
                <div class="cel-info-pesticides">
                  <span class="strong-cel-info-pesticides"
                    >Classe ambiental</span
                  >
                  <span>{{
                    this.selectedTabData.classeAmbiental?.nome ||
                    "Não informado"
                  }}</span>
                </div>
              </div>
            </div>
            <div class="container-card-bule">
              <div class="content-card-bule">
                <div
                  class="card-bule"
                  @click="openUrl(this.selectedTabData.urlBula)"
                >
                  <b-icon-card-heading
                    class="icon-card-bule"
                  ></b-icon-card-heading>
                  <span> Bula </span>
                </div>
                <div
                  class="card-bule"
                  @click="openUrl(this.selectedTabData.urlFispq)"
                >
                  <b-icon-x-diamond class="icon-card-bule"></b-icon-x-diamond>
                  <span> FDS </span>
                </div>
                <div
                  class="card-bule"
                  @click="openUrl(this.selectedTabData.urlFicha)"
                >
                  <b-icon-truck class="icon-card-bule"></b-icon-truck>
                  <span> FET </span>
                </div>
              </div>
              <div class="content-sketch-btn">
                <button v-b-modal.modal-center1 class="sketch-btn">
                  Imprimir ficha
                </button>
                <button v-b-modal.modal-center1 class="sketch-btn">
                  Imprimir várias fichas
                </button>
                <button v-b-modal.modal-center1 class="sketch-btn">
                  Relatório de produto
                </button>
              </div>
            </div>
          </div>
          <div
            class="content-pesticides"
            style="align-items: flex-start; gap: 5px; margin-bottom: 30px"
            v-if="selectedLabel === 'Aplicação por Cultura'"
          >
            <div class="aplic-culture-content">
              <div class="headerTables" style="text-align: start">
                <span style="width: 20%">Cultura</span>
                <span style="width: 25%">Intervalo de segurança</span>
                <span style="width: 25%">Intervalo de aplicações</span>
                <span style="width: 25%">N° Max de aplicações</span>
                <span style="width: 15%">Reentrada</span>
              </div>
              <div
                v-for="aplication in aplications"
                :key="aplication.id"
                class="content-card-aplic-culture"
                @click="toggleCollapseCulture(aplication)"
              >
                <div class="card-aplic-culture">
                  <div class="celTable" style="width: 20%">
                    <span class="textEllipsis">
                      <strong
                        style="
                          color: #3e66ae;
                          font-weight: bold;
                          text-transform: uppercase;
                          padding-left: 3px;
                        "
                        >{{ aplication.cultura.nome }}</strong
                      >
                    </span>
                  </div>
                  <div class="celTable" style="width: 25%">
                    <span class="textEllipsis">{{
                      aplication.intervaloSeguranca
                    }}</span>
                  </div>
                  <div class="celTable" style="width: 25%">
                    <span class="textEllipsis">{{
                      aplication.intervaloEntreAplicacoes
                    }}</span>
                  </div>
                  <div class="celTable" style="width: 25%">
                    <span class="textEllipsis">{{
                      aplication.numeroAplicacao || "0"
                    }}</span>
                  </div>
                  <div class="celTable" style="width: 15%">
                    <span class="textEllipsis">{{
                      aplication.intervaloReentrada
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="this.selectedCulture"
              style="
                display: flex;
                flex-direction: column;
                border: 2px dashed rgb(214, 214, 214);
                border-radius: 8px;
                width: 100%;
                font-size: 13px;
                text-align: start;
                background: whitesmoke;
              "
            >
              <div class="headerTables" style="text-align: center">
                {{ this.selectedCulture }}
              </div>
              <span style="padding: 15px 10px">
                {{ this.moreInfoCulture }}
              </span>
            </div>
          </div>
          <div class="content-pesticides" v-if="selectedLabel === 'Indicações'">
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: center;
                padding-bottom: 10px;
              "
            >
              <span
                style="font-size: 12px; text-align: start; font-weight: bold"
                >Mostrando {{ this.indications.length }} Indicações</span
              >
              <div class="searchInput" style="border: none !important">
                <b-input
                  size="sm"
                  placeholder="Pesquisar"
                  v-model="filterInd"
                  class="inputSearch shadow-none"
                  @input="filterIndications(filterInd)"
                ></b-input>
                <b-button
                  size="sm"
                  @click="filterIndications(filterInd)"
                  class="searchBtn"
                >
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>
            </div>
            <div
              class="aplic-culture-indication-loading"
              v-if="loadingIndications"
            >
              <div class="newtons-cradle">
                <div class="newtons-cradle__dot"></div>
                <div class="newtons-cradle__dot"></div>
                <div class="newtons-cradle__dot"></div>
                <div class="newtons-cradle__dot"></div>
              </div>
            </div>
            <div class="aplic-culture-indication" v-else>
              <div
                v-for="(indication, index) in indications"
                :key="index"
                class="content-card-aplic-indication"
                :class="{ expanded: expandedIndicationId === index }"
                @click="toggleCollapseIndication(index)"
              >
                <div class="card-aplic-indication" style="gap: 0px">
                  <div class="celTable" style="width: 100%">
                    <span class="textEllipsis" style="display: flex; gap: 5px">
                      <strong>Cultura: </strong>
                      <strong
                        style="
                          color: #3e66ae;
                          font-weight: bold;
                          text-transform: uppercase;
                          padding-left: 3px;
                        "
                        >{{ indication.nome }}</strong
                      >
                    </span>
                  </div>
                  <div class="celTable" style="width: 100%">
                    <span class="textEllipsis" style="display: flex; gap: 5px">
                      <strong>Nome comum: </strong>
                      {{ indication.nomeComum }}</span
                    >
                  </div>
                  <div class="celTable" style="width: 100%">
                    <span class="textEllipsis" style="display: flex; gap: 5px">
                      <strong>Nome científico: </strong>
                      {{ indication.nomeCientifico }}</span
                    >
                  </div>
                </div>
                <div style="background: rgb(230, 230, 230); border-radius: 8px">
                  <div class="description-wrapper">
                    <div
                      style="
                        display: flex;
                        width: 100%;
                        flex-direction: column;
                        padding-left: 5px;
                      "
                    >
                      <div
                        class="textEllipsisaplic"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          width: 100%;
                          gap: 5px;
                        "
                      >
                        <span style="font-weight: bold"> Doses: </span>
                        <span>
                          {{ indication.doseMinima }} a
                          {{ indication.doseMaxima }}
                          {{ indication.unidadeDose }}
                        </span>
                      </div>
                      <div
                        class="textEllipsisaplic"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          align-items: flex-start;
                          flex-direction: column;
                          width: 100%;
                        "
                      >
                        <span style="font-weight: bold"> Volumes calda: </span>
                        <span>
                          {{ indication.doseMinimaVolumeCalda }} a
                          {{ indication.doseMaximaVolumeCalda }}
                          {{ indication.unidadeVolumeCalda }}
                        </span>
                      </div>
                      <div
                        class="textEllipsisaplic"
                        style="
                          display: flex;
                          justify-content: flex-start;
                          width: 100%;
                          gap: 5px;
                        "
                      >
                        <span style="font-weight: bold"> Solos: </span>
                        <span> {{ indication.solo }} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="content-pesticides"
            v-if="selectedLabel === 'Modalidades de Aplicação'"
          >
            <div class="mod-aplic-content" v-if="selectedTabData.aplicacao">
              <h3 style="font-size: 16px; font-weight: bold">
                Modo geral de aplicação
              </h3>
              <span>{{ selectedTabData.aplicacao }}</span>
            </div>

            <div
              class="content-option-mod-aplic-content"
              v-if="
                aplicationsMethods && aplicationsMethods.aplicacoes.length > 0
              "
            >
              <div class="option-mod-aplic-content">
                <div class="container-radio">
                  <!-- <div class="custom-radio">
                    <template
                    v-for="app in aplicationsMethods.aplicacoes"
                    >
                    <input
                    :key="app.id"
                        type="radio"
                        :id="'app-' + app.id"
                        name="application_method"
                        :value="app.id"
                        v-model="selectedApplicationId"
                      />
                      <label
                        :key="app.id + '-label'"
                        class="radio-label"
                        :for="'app-' + app.id"
                      >
                        <div class="radio-circle"></div>
                        <span class="radio-text">{{
                          app.tiposAplicacoes.nome
                        }}</span>
                      </label>
                    </template>
                  </div> -->
                </div>
              </div>

              <div class="mod-aplic-content-info">
                <h3 style="font-size: 16px; font-weight: bold">
                  Detalhes da Aplicação
                </h3>
                <span style="white-space: pre-wrap">
                  {{ selectedApplicationDescription }}
                </span>
              </div>
            </div>
            <div v-else>
              <span>Carregando modalidades de aplicação...</span>
            </div>
          </div>
          <div
            class="content-pesticides"
            v-if="selectedLabel === 'Restrições por Estado'"
          >
            <div class="container-restriction">
              <div class="content-general-states">
                <span
                  style="
                    font-size: 14px;
                    width: 100%;
                    text-align: start;
                    border-bottom: 1px solid #3e66ae;
                    font-weight: bold;
                  "
                >
                  Restrições Gerais
                </span>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    padding: 20px;
                    gap: 10px;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <div style="display: flex; gap: 10px">
                    <img style="width: 60px; height: 40px" :src="Acre" />
                    <img style="width: 60px; height: 40px" :src="Alagoas" />
                    <img style="width: 60px; height: 40px" :src="Amapa" />
                    <img style="width: 60px; height: 40px" :src="Amazonas" />
                    <img style="width: 60px; height: 40px" :src="Bahia" />
                    <img style="width: 60px; height: 40px" :src="Ceara" />
                    <img style="width: 60px; height: 40px" :src="Espirito" />
                    <img style="width: 60px; height: 40px" :src="Goias" />
                    <img style="width: 60px; height: 40px" :src="Maranhao" />
                    <img style="width: 60px; height: 40px" :src="MatoGrosso" />
                    <img style="width: 60px; height: 40px" :src="MatoSul" />
                    <img style="width: 60px; height: 40px" :src="Minas" />
                  </div>
                  <div style="display: flex; gap: 10px">
                    <img style="width: 60px; height: 40px" :src="Para" />
                    <img style="width: 60px; height: 40px" :src="Paraiba" />
                    <img style="width: 60px; height: 40px" :src="Pernambuco" />
                    <img style="width: 60px; height: 40px" :src="Piaui" />
                    <img style="width: 60px; height: 40px" :src="Rio" />
                    <img
                      style="width: 60px; height: 40px"
                      :src="RioGrandeNorte"
                    />
                    <img
                      style="width: 60px; height: 40px"
                      :src="RioGrandeSul"
                    />
                    <img style="width: 60px; height: 40px" :src="Rondonia" />
                    <img style="width: 60px; height: 40px" :src="Roraima" />
                    <img
                      style="width: 60px; height: 40px"
                      :src="SantaCatarina"
                    />
                    <img style="width: 60px; height: 40px" :src="SaoPaulo" />
                    <img style="width: 60px; height: 40px" :src="Sergipe" />
                    <img style="width: 60px; height: 40px" :src="Tocantins" />
                  </div>
                </div>
              </div>
              <div class="content-alvo">
                <span
                  style="
                    font-size: 14px;
                    width: 100%;
                    text-align: start;
                    border-bottom: 1px solid #3e66ae;
                    font-weight: bold;
                  "
                >
                  Restrições por Alvo
                </span>
                <div class="aplic-culture-content">
                  <div
                    class="content-card-aplic-culture"
                    :class="{ expanded: isCollapsedCulture }"
                    @click="toggleCollapseCulture"
                  >
                    <div class="card-aplic-culture">
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Cultura: </strong>
                          <strong
                            style="
                              color: #3e66ae;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >Algodão</strong
                          >
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome comum: </strong>
                          Algodão</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome científico: </strong>
                          Raphanus raphanistrum</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>UF: </strong>
                          Minas Gerais</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="content-card-aplic-culture"
                    :class="{ expanded: isCollapsedCulture }"
                    @click="toggleCollapseCulture"
                  >
                    <div class="card-aplic-culture">
                      <div class="celTable">
                        <span class="textEllipsis"
                          ><strong>Cultura: </strong>
                          <strong
                            style="
                              color: #3e66ae;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >Algodão</strong
                          >
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome comum: </strong>Algodão
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome científico: </strong> Raphanus
                          raphanistrum</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>UF: </strong>
                          Minas Gerais</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-culture-restriction">
                <span
                  style="
                    font-size: 14px;
                    width: 100%;
                    text-align: start;
                    border-bottom: 1px solid #3e66ae;
                    font-weight: bold;
                  "
                >
                  Restriçoes por Cultura
                </span>
                <div class="aplic-culture-content">
                  <div
                    class="content-card-aplic-culture"
                    :class="{ expanded: isCollapsedCulture }"
                    @click="toggleCollapseCulture"
                  >
                    <div class="card-aplic-culture">
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Cultura: </strong>
                          <strong
                            style="
                              color: #3e66ae;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >Algodão</strong
                          >
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome comum: </strong>
                          Algodão</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome científico: </strong>
                          Raphanus raphanistrum</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>UF: </strong>
                          Minas Gerais</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="content-card-aplic-culture"
                    :class="{ expanded: isCollapsedCulture }"
                    @click="toggleCollapseCulture"
                  >
                    <div class="card-aplic-culture">
                      <div class="celTable">
                        <span class="textEllipsis"
                          ><strong>Cultura: </strong>
                          <strong
                            style="
                              color: #3e66ae;
                              font-weight: bold;
                              text-transform: uppercase;
                              padding-left: 3px;
                            "
                            >Algodão</strong
                          >
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome comum: </strong>Algodão
                        </span>
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>Nome científico: </strong> Raphanus
                          raphanistrum</span
                        >
                      </div>
                      <div class="celTable">
                        <span class="textEllipsis">
                          <strong>UF: </strong>
                          Minas Gerais</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="content-info-additionals"
            v-if="selectedLabel === 'Informações Adicionais'"
          >
            <div
              style="
                display: flex;
                width: 100%;
                justify-content: space-between;
                align-items: start;
              "
            >
              <div
                v-for="(group, groupIndex) in radioGroups"
                :key="groupIndex"
                class="container-radio"
              >
                <div class="custom-radio">
                  <!-- <template v-for="item in group">
                    <input
                      :key="item.key + '-input'"
                      type="radio"
                      :id="item.key"
                      name="tabs"
                      :value="item.key"
                      v-model="selectedInfoKey"
                    />
                    <label
                      :key="item.key + '-label'"
                      class="radio-label"
                      style="padding: 4px"
                      :for="item.key"
                    >
                      <div class="radio-circle"></div>
                      <span class="radio-text">{{ item.label }}</span>
                    </label>
                  </template> -->
                </div>
              </div>
            </div>

            <div class="content-info-additional" v-if="infoAdditionals">
              <span style="white-space: pre-wrap">
                {{ displayedText }}
              </span>
            </div>
            <div v-else>
              <span>Carregando informações...</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      class="tabOptions"
      v-if="isTabOptionsVisible"
      :style="tabOptionsStyle"
      @click.stop
    >
      <span
        v-for="(option, idx) in defaultOptions"
        :key="idx"
        @click="selectNewTabOption(option.value, option.text)"
        >{{ option.text }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import WinfitSpinner from "../../assets/winfit-spinner.png";
import Acre from "../../assets/States/acre.jpg";
import Alagoas from "../../assets/States/alagoas.jpg";
import Amapa from "../../assets/States/amapa.jpg";
import Amazonas from "../../assets/States/amazonas.jpg";
import Bahia from "../../assets/States/bahia.jpg";
import Ceara from "../../assets/States/ceara.jpg";
import Espirito from "../../assets/States/espirito_santo.jpg";
import Goias from "../../assets/States/goias.jpg";
import Maranhao from "../../assets/States/maranhao.jpg";
import MatoGrosso from "../../assets/States/mato_grosso.jpg";
import MatoSul from "../../assets/States/mato_grosso_do_sul.jpg";
import Minas from "../../assets/States/minas_gerais.jpg";
import Para from "../../assets/States/para.jpg";
import Paraiba from "../../assets/States/paraiba.jpg";
import Pernambuco from "../../assets/States/pernambuco.jpg";
import Piaui from "../../assets/States/piaui.jpg";
import Rio from "../../assets/States/rio_de_janeiro.jpg";
import RioGrandeNorte from "../../assets/States/rio_grande_do_norte.jpg";
import RioGrandeSul from "../../assets/States/rio_grande_do_sul.jpg";
import Rondonia from "../../assets/States/rondonia.jpg";
import Roraima from "../../assets/States/roraima.jpg";
import SantaCatarina from "../../assets/States/santa_catarina.jpg";
import SaoPaulo from "../../assets/States/sao_paulo.jpg";
import Sergipe from "../../assets/States/sergipe.jpg";
import Tocantins from "../../assets/States/tocantins.jpg";
import ServiceCompendio from "../../services/serviceCompendio";
// import Cancellations from "./Cancellations";
// import Cultures from "./Cultures";
// import Diagnosis from "./Diagnosis";
// import Ingredients from "./Ingredients";
// import Manufacturers from "./Manufacturers";
// import Restriction from "./Restriction";
// import UpdatesPesticides from "./UpdatesPesticides";

export default {
  data() {
    return {
      winfitSpinner: WinfitSpinner,
      Acre: Acre,
      Alagoas: Alagoas,
      Amapa: Amapa,
      Amazonas: Amazonas,
      Bahia: Bahia,
      Ceara: Ceara,
      Espirito: Espirito,
      Goias: Goias,
      Maranhao: Maranhao,
      MatoGrosso: MatoGrosso,
      MatoSul: MatoSul,
      Minas: Minas,
      Para: Para,
      Paraiba: Paraiba,
      Pernambuco: Pernambuco,
      Piaui: Piaui,
      Rio: Rio,
      RioGrandeNorte: RioGrandeNorte,
      RioGrandeSul: RioGrandeSul,
      Rondonia: Rondonia,
      Roraima: Roraima,
      SantaCatarina: SantaCatarina,
      SaoPaulo: SaoPaulo,
      Sergipe: Sergipe,
      Tocantins: Tocantins,
      commonNameSearch: "",
      debounceTimeout: null,
      pesticideResults: [],
      tabList: [],
      aplications: [],
      indications: [],
      allIndications: [],
      infoAdditionals: null,
      aplicationsMethods: null,
      selectedApplicationId: null,
      filterInd: "",
      moreInfoCulture: "",
      selectedCulture: "",
      loadingPesticides: false,
      loadingIndications: false,
      isCollapsedCulture: false,
      isTabOptionsVisible: false,
      tabOptionsStyle: {},
      selectedLabel: "Informações Gerais",
      defaultOptions: [
        { value: "agrotoxicos", text: "Agrotóxicos" },
        { value: "culturas", text: "Culturas" },
        { value: "diagnosticos", text: "Diagnóstico" },
        { value: "atualizacoes", text: "Atualizações do Produto" },
        { value: "ingredientes", text: "Ingredientes Ativos" },
        { value: "fabricantes", text: "Fabricantes" },
        { value: "restricao", text: "Restrição por Estado" },
        { value: "cancelamentos", text: "Cancelamentos" },
      ],
      tabs: [
        { value: "Informações Gerais", text: "Informações Gerais" },
        { value: "Aplicação por Cultura", text: "Aplicação por Cultura" },
        { value: "Indicações", text: "Indicações" },
        { value: "Modalidades de Aplicação", text: "Modalidades de Aplicação" },
        { value: "Restrições por Estado", text: "Restrições por Estado" },
        { value: "Informações Adicionais", text: "Informações Adicionais" },
      ],
      expandedCultureId: null,
      expandedIndicationId: null,
      selectedTabData: null,
      selectedInfoKey: "precaucoes",
      radioGroups: [
        [
          { label: "Precauções Gerais (saúde humana)", key: "precaucoes" },
          { label: "Precauções de Uso (meio ambiente)", key: "prevencoes" },
          { label: "Embalagens", key: "embalagens" },
          {
            label: "Disposição final de resíduos e embalagens",
            key: "disposicoesFinais",
          },
        ],
        [
          {
            label: "Grau de inflamabilidade",
            key: "grausdeinflamabilidadeCollection",
          },
          { label: "Incompatibilidades", key: "incompatibilidades" },
          { label: "Composição", key: "composicao" },
          { label: "Alterações do Registro (DOU)", key: "observacaoRestricao" },
        ],
        [
          { label: "Preparo Calda", key: "preparoCalda" },
          { label: "Condições Climáticas", key: "condicaoClimatica" },
          { label: "Limpeza de Tanque", key: "limpezaTanque" },
          { label: "Manejo de Resistência", key: "manejoResistencia" },
        ],
        [
          { label: "Manejo de Pragas", key: "manejoPragaDoenca" },
          { label: "Intoxicação", key: "intoxicacao" },
          { label: "Limitação de uso", key: "misturaTanque" },
        ],
      ],
      isSearchCollapsed: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_NEW_CONSULTATIONS_TAB",
      "SET_TAB_CONSULTATIONS_SELECTED",
      "REMOVE_CONSULTATION_TAB",
    ]),
    selectPesticide(pesticide) {
      this.selectedTabData = pesticide;
      this.selectedLabel = "Informações Gerais";
      this.aplications = [];
      this.indications = [];
      this.allIndications = [];
      this.aplicationsMethods = null;
      this.infoAdditionals = null;
    },
    async storeLabelName(labelName) {
      this.selectedLabel = labelName;
      if (this.selectedLabel === "Aplicação por Cultura") {
        this.aplications = await ServiceCompendio.findApplicationsByCrop(
          this.selectedTabData.id
        );
      }
      if (this.selectedLabel === "Indicações") {
        this.loadingIndications = true;
        try {
          const result = await ServiceCompendio.findUsageIndications(
            this.selectedTabData.id
          );
          this.indications = result;
          this.allIndications = result;
        } catch (error) {
          console.log(error);
        } finally {
          this.loadingIndications = false;
        }
      }
      if (this.selectedLabel === "Informações Adicionais") {
        try {
          const result = await ServiceCompendio.findInfoAdditionals(
            this.selectedTabData.id
          );
          this.infoAdditionals = result;
        } catch (error) {
          console.log(error);
        }
      }
      if (this.selectedLabel === "Modalidades de Aplicação") {
        try {
          const result = await ServiceCompendio.findApplicationMethods(
            this.selectedTabData.id
          );
          this.aplicationsMethods = result;
        } catch (error) {
          console.log(error);
        }
      }
    },
    toggleCollapseCulture(data) {
      this.moreInfoCulture = data.descricaoAplicacao;
      this.selectedCulture = data.cultura.nome;
      this.expandedCultureId =
        this.expandedCultureId === data.id ? null : data.id;
    },

    filterIndications(filterText) {
      this.loadingIndications = true;
      try {
        const term = filterText.trim().toLowerCase();
        if (term === "") {
          this.indications = this.allIndications;
        } else {
          this.indications = this.allIndications.filter((ind) =>
            ind.nome.toLowerCase().includes(term)
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingIndications = false;
      }
    },
    toggleCollapseIndication(id) {
      this.expandedIndicationId = this.expandedIndicationId === id ? null : id;
    },
    addNewTab(value, text) {
      this.SET_NEW_CONSULTATIONS_TAB({ value, text, pesticideData: null });
      this.$nextTick(() => {
        const container = this.$el.querySelector(".navigations");
        if (container) {
          container.scrollLeft = container.scrollWidth;
        }
      });
    },
    toggleTabOptions(event) {
      if (this.isTabOptionsVisible) {
        this.closeTabOptions();
        return;
      }
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      if (this.tabListConsultations.length === 0) {
        this.tabOptionsStyle = {
          top: `${rect.bottom + 5}px`,
          right: `${window.innerWidth - rect.right - rect.right - 80}px`,
        };
      } else {
        this.tabOptionsStyle = {
          top: `${rect.bottom + 5}px`,
          right: `${window.innerWidth - rect.right}px`,
        };
      }

      this.isTabOptionsVisible = true;
      document.addEventListener("click", this.closeTabOptions);
    },
    closeTabOptions() {
      this.isTabOptionsVisible = false;
      document.removeEventListener("click", this.closeTabOptions);
    },
    selectNewTabOption(value, text) {
      this.addNewTab(value, text);
      this.closeTabOptions();
    },
    openUrl(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$bvToast.toast("URL não disponível.", {
          title: "Aviso",
          variant: "warning",
          solid: true,
        });
      }
    },
    getCardColor(pesticide) {
      if (
        !pesticide ||
        !pesticide.classeToxicologica ||
        !pesticide.classeToxicologica.classificacao
      ) {
        return "#cfcfcf";
      }

      const classificacao = pesticide.classeToxicologica.classificacao;

      if (
        classificacao === "I" ||
        classificacao === "Categoria 1" ||
        classificacao === "Categoria 2"
      ) {
        return "red";
      } else if (classificacao === "II" || classificacao === "Categoria 3") {
        return "yellow";
      } else if (
        classificacao === "III" ||
        classificacao === "Categoria 4" ||
        classificacao === "Categoria 5"
      ) {
        return "blue";
      } else if (classificacao === "IV") {
        return "green";
      } else if (
        classificacao.toUpperCase() === "NÃO CLASSIFICADO" ||
        classificacao === "*"
      ) {
        return "green";
      } else {
        return "#cfcfcf";
      }
    },
    openPesticideTab(pesticide) {
      const existingTab = this.tabListConsultations.find(
        (tab) => tab.pesticideData && tab.pesticideData.id === pesticide.id
      );

      if (existingTab) {
        this.selectedTab(existingTab.idList);
      } else {
        this.SET_NEW_CONSULTATIONS_TAB({
          value: "aba",
          text: pesticide.nomeComum,
          pesticideData: pesticide,
        });
      }

      this.$nextTick(() => {
        const container = this.$el.querySelector(".navContainer");
        if (container) {
          container.scrollLeft = container.scrollWidth;
        }
      });
    },
    selectedTab(idList) {
      this.SET_TAB_CONSULTATIONS_SELECTED(idList);
    },
    closeTab(tabId) {
      this.REMOVE_CONSULTATION_TAB(tabId);
    },
    async searchPesticidesByName(name) {
      this.loadingPesticides = true;
      try {
        const results = await ServiceCompendio.findPesticideByCommonName(name);
        this.pesticideResults = results;
        this.fakeResults = results;
      } catch (error) {
        console.error("Erro ao buscar pesticidas:", error);
        this.pesticideResults = [];
      } finally {
        this.loadingPesticides = false;
      }
    },
    beforeDestroy() {
      this.closeTabOptions();
    },
  },
  computed: {
    ...mapState(["tabListConsultations"]),
    // selectedTabData() {
    //   return this.tabListConsultations?.find((tab) => tab.isSelected) || null;
    // },
    displayedText() {
      if (!this.infoAdditionals || !this.selectedInfoKey) {
        return "Nenhuma informação para exibir.";
      }
      return (
        this.infoAdditionals[this.selectedInfoKey] ||
        "Nenhuma informação disponível para esta seção."
      );
    },
    selectedApplicationDescription() {
      if (!this.aplicationsMethods || !this.selectedApplicationId) {
        return "Selecione um método de aplicação para ver os detalhes.";
      }

      const selectedApp = this.aplicationsMethods.aplicacoes.find(
        (app) => app.id === this.selectedApplicationId
      );

      return selectedApp ? selectedApp.descricao : "Descrição não encontrada.";
    },
  },
  watch: {
    commonNameSearch(newVal) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        if (newVal.length >= 3) {
          this.searchPesticidesByName(newVal);
        } else {
          this.pesticideResults = [];
        }
      }, 1200);
    },
  },
  async mounted() {
    await this.searchPesticidesByName("1");
    if (this.pesticideResults.data && this.pesticideResults.data.length > 0) {
      this.selectPesticide(this.pesticideResults.data[0]);
    }
  },
};
</script>

<style scoped>
.containerGeneral {
  width: 100%;
  padding-top: 70px;
  padding-left: 70px;
  height: auto;
  overflow: auto;
  margin: 0 10px 0 0;
  display: flex;
  gap: 10px;
  transition: all 0.4s ease-in-out;
}
.content-info-additional span {
  white-space: pre-wrap;
  word-break: break-word;
}
.containerConsultation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  height: calc(100vh - 70px);
  position: relative;
  flex-shrink: 0;
  width: 20%;
  transition: width 0.4s ease-in-out;
  overflow: hidden;
}

.contentGeneral {
  position: relative;
  padding: 0 1rem;
  flex-grow: 1;
  width: 80%;
  transition: width 0.4s ease-in-out;
  overflow-y: auto;
  height: calc(100vh - 70px);
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 rgba(99, 99, 99, 0.2);
  background-color: white;
}

.containerGeneral.search-collapsed .containerConsultation {
  width: 40px;
}

.containerGeneral.search-collapsed .contentGeneral {
  width: calc(100% - 40px);
}

.consultation-content {
  transition: opacity 0.2s linear;
}

.containerGeneral.search-collapsed .consultation-content {
  opacity: 0;
}

.consultation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: hidden;
}

.collapse-toggle {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 25px;
  height: 50px;
  background-color: #f0f0f0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #ccc;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}

.collapse-toggle:hover {
  background-color: #e0e0e0;
}

.collapse-toggle .arrow {
  font-size: 24px;
  color: #344d67;
  font-weight: bold;
}

.content-pesticides {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  transition: all 0.3s ease;
  user-select: none;
}

.content-info-additionals {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  color: #333;
  font-size: 18px;
  font-weight: 500;
  transition: all 0.3s ease;
  user-select: none;
}

.title-pesticides {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  padding-left: 30px;
}

.loading-text {
  font-size: 4rem;
  height: 80px;
  font-weight: bold;
  text-transform: uppercase;
  background: url("../../assets/bg.jpeg") repeat;
  background-size: contain;
  background-position: 0 50%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: moveBackground 15s linear infinite;
}

@keyframes moveBackground {
  from {
    background-position: 0 50%;
  }
  to {
    background-position: 100% 50%;
  }
}

.container-info-pesticides {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 2px;
  padding: 10px;
  font-size: 13px;
  border: 3px double rgb(196, 196, 196);
  border-left: none;
  border-right: none;
}

.container-card-bule {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 7px;
  padding: 10px;
  font-size: 13px;
}

.content-info-pesticides {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 50%;
  gap: 10px;
  font-size: 13px;
  padding-left: 50px;
}

.cel-info-pesticides {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-size: 13px;
}

.card-bule {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100px;
  width: 80px;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.icon-card-bule {
  background: rgb(216, 216, 216);
  width: 100%;
  height: 75px;
  padding: 0 15px 15px 15px;
  border-radius: 5px;
  display: flex;
}

.content-card-bule {
  width: 50%;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

.strong-cel-info-pesticides {
  font-weight: 600;
  color: #006459;
}

.content-sketch-btn {
  display: flex;
  width: 50%;
  gap: 10px;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
}

.sketch-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(216, 216, 216);
  border: 1px solid #006459;
  color: #006459;
  border-radius: 3px;
  width: 31.5%;
  height: 25px;
  gap: 10px;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  padding-top: 10px;
  width: 100%;
  gap: 1px;
  transition: transform 0.5s ease-in-out;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 25px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 10px;
  background: #e4e4e4;
  color: #000000;
  font-size: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 26px;
  background-color: #ffffff;
  color: #006458;
  border-bottom: 4px solid #006458;
  padding-bottom: 1px;
  border-radius: 10px 10px 0 0;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #006458;
  color: white;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.headerTables {
  display: flex;
  width: 100%;
  background: #006458;
  color: whitesmoke;
  font-size: 12px;
  text-align: center;
  border-radius: 8px 8px 0 0;
  padding: 5px 10px;
}

.aplic-culture-content {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  width: 100%;
  max-width: 100%;
  gap: 2px;
  border: 2px solid rgb(255, 255, 255);
  border-radius: 8px;
  max-height: 60vh;
}

.aplic-culture-indication {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  padding: 20px;
  width: 100%;
  gap: 10px;
  border: 2px dashed #d6d6d6;
  border-radius: 8px;
  justify-content: center;
}
.aplic-culture-indication-loading {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  padding: 20px;
  width: 100%;
  gap: 10px;
  height: 50vh;
  border: 2px dashed #d6d6d6;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
}

.content-card-aplic-culture {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 5px 10px;
  width: 100%;
  max-width: 100%;
  gap: 5px;
  min-height: 35px;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.207);
  justify-content: center;
  transition: background 0.3s ease;
  cursor: pointer;
}

.content-card-aplic-indication {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 5px 10px;
  width: 24%;
  max-width: 24%;
  gap: 5px;
  min-height: 45px;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.207);
  justify-content: center;
  transition: background 0.3s ease;
}

.card-aplic-culture {
  display: flex;
  align-items: center;
  text-align: center;
  gap: 20px;
  cursor: pointer;
  font-size: 12px;
}

.card-aplic-indication {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  cursor: pointer;
  font-size: 12px;
}

.content-card-aplic-culture:hover {
  background: rgb(242, 242, 242);
}

.content-card-aplic-indication:hover {
  background: rgb(242, 242, 242);
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.textEllipsisaplic {
  display: block;
  font-size: 12px;
  color: #333;
  text-align: center;
  padding: 15px 0px 5px 0px;
}

.collapsible-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
  background: rgb(230, 230, 230);
  border-radius: 8px;
}

.content-card-aplic-indication.expanded .collapsible-content {
  max-height: 200px;
  opacity: 1;
  transition: max-height 0.3s ease-in;
}

.content-card-aplic-culture.expanded .collapsible-content {
  max-height: 200px;
  opacity: 1;
  transition: max-height 0.3s ease-in;
}

.mod-aplic-content {
  width: 100%;
  padding: 10px;
  font-size: 12px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
}

.mod-aplic-content-info {
  width: 75%;
  padding: 20px;
  border-radius: 5px;
  font-size: 12px;
  color: #333;
  display: flex;
  background: rgb(233, 233, 233);
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
}

.content-option-mod-aplic-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  gap: 10px;
  font-size: 14px;
  color: #333;
  display: flex;
  text-align: start;
  max-height: 70vh;
  overflow: scroll;
}

.emptyState {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: white;
  overflow-y: auto !important;
  border: 2px dashed #e3e3e3;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes pop-in {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  70% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

.tab-animation-enter-active {
  animation: pop-in 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.navContainer {
  width: 100%;
  padding: 0 1rem;
}

.navigations {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
  padding-bottom: 5px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.navigations::-webkit-scrollbar {
  display: none;
}

.tab {
  flex: 0 0 auto;
  min-width: 150px;
  max-width: 250px;
  padding: 0.5rem 0.2rem 0.5rem 0.5rem;
  height: 35px;
  background-color: rgb(244, 244, 244);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.3rem;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  color: #344d67;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid #ddd;
}

.tabSelected {
  background-color: #344d67 !important;
  color: white !important;
  font-size: 13px;
  transition: ease-in all 0.2s;
  transform: translate(0, -3px);
  border-bottom-color: transparent;
}

.tabSelected::after {
  content: "";
  height: 0;
  width: 0;
  background-color: transparent;
  position: absolute;
  bottom: -3px;
  left: 0;
}

.textTab {
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
}

.iconCloseTab {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #666;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.137);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 15px;
  transform: rotate(45deg) !important;
  font-weight: 500 !important;
  transition: ease-in all 0.1s;
  user-select: none;
}

.iconCloseTabSelected {
  color: white !important;
}

.searchInput {
  width: 20%;
  display: flex;
}

.searchBtn {
  right: 10px;
  height: 31px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

.iconCloseTab:hover {
  background-color: #344d67;
  transition: ease-in all 0.1s;
}

.btnNewTab {
  position: sticky;
  right: -1px;
  z-index: 10;
  background: white;
  padding: 0 5px;
  height: 45px;
  display: flex;
  align-items: center;
}

.btnNewTab .iconAddTab {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #344d67;
  cursor: pointer;

  right: 0;
  top: 8px;
  color: white;
  background-color: #344d67;
  box-shadow: 0 0.5px 2px 1px rgba(0, 0, 0, 0.366);
  width: 25px;
  height: 25px;
  border-radius: 8px 8px 8px 0;
  font-size: 25px;
  font-weight: 500 !important;
  transition: ease-in all 0.1s;
  cursor: pointer;
  user-select: none;
}

.iconAddTab:hover {
  background-color: #0bc06f;
  transition: ease-in all 0.1s;
}

#newOption {
  position: relative;
  transition: ease 0.3s;
}

#newOption:checked + .iconAddTab {
  transform: rotate(-45deg);
  transition: ease 0.3s;
}

#newOption:checked ~ .tabOptions {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.tabOptions {
  position: fixed;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  min-width: 220px;
  padding: 5px;
  z-index: 9999;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tabOptions span {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 3px;
  font-size: 14px;
  color: #006458;
  font-weight: bold;
}

.tabOptions span:hover {
  background-color: #dedede;
}

.formContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  height: 60px;
  width: 100%;
}

.collapseIcon {
  cursor: pointer;
  color: #0bc06f;
  z-index: 2;
  margin-left: 1rem;
}

.searchFormOthers {
  display: flex;
  gap: 10px;
  background: #eee;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  justify-content: flex-end;
}
.searchForm {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  background: #eee;
  padding: 10px;
  z-index: 1;
  width: 100%;
}

.formGroup {
  display: flex;
  flex-direction: column;
}
.searchInput,
.searchSelect {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 15px;
}
/* .searchButton {
  display: inline-block;
  position: absolute;
  right: 0px;
  padding: 2px 12px;
  border: none;
  background: #0bc06f;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.searchButton:hover {
  background-color: #09a05d;
} */

h2 {
  width: 100%;
  color: #344d67;
  font-size: 22px;
  font-weight: 600;
  padding-top: 10px;
  border-top: 35px solid #0000ff;
  text-align: center;
  text-transform: uppercase;
}

.input-container {
  position: relative;
  width: 100%;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #2a8314;
  font-size: 11px;
  font-weight: 500;
}

.input[type="text"] {
  padding: 5px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  background-color: white;
  color: #333;
  outline: none;
  width: 100%;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #016011 0%,
    #0bc06f 46%,
    #ffcc70 100%
  );
  transition: width 0.3s;
}

.input[type="text"]:focus + .underline {
  width: 100%;
}

@keyframes floating-label {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-25px);
    opacity: 0;
  }
}

.input[type="text"]:placeholder-shown + label {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 14px;
  color: #777;
  pointer-events: none;
  transition: transform 0.3s, font-size 0.3s, color 0.3s;
}

.input[type="text"]:focus:not(:placeholder-shown) + label {
  transform: translateY(-25px);
  font-size: 12px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #4158d0 0%,
    #c850c0 46%,
    #ffcc70 100%
  );
  animation: floating-label 0.3s forwards;
}

.contentCards {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  background: #eee;
  padding: 10px;
  border-radius: 5px;
  overflow: scroll;
  height: 70vh;
}

.productCard {
  position: relative;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.productCard::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  background: var(--card-color);
}

.cardHeader {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  width: 100%;
}

.barsIcon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 4px;
  height: 24px;
  margin-right: 8px;
}

.barsIcon span {
  display: block;
  height: 4px;
  background: var(--card-color);
  border-radius: 2px;
}

.productTitle {
  margin: 0;
  font-size: 13px;
  color: #004466;
  font-weight: 600;
}

.registerTitle {
  margin: 0;
  font-size: 11px;
  padding: 0 10px 5px 0;
  text-align: end;
  width: 100%;
  color: #2f2f2f;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
}

.cardBody {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 0.75rem;
  -moz-column-gap: 1rem;
  column-gap: 0.3rem;
  padding: 0 0.5rem 0.5rem;
  font-size: 11px;
  color: #333;
}

.info .label {
  font-size: 11px;
  text-transform: uppercase;
  color: #777;
  margin-bottom: 2px;
}

.info .value {
  line-height: 1;
}

.cultures {
  grid-column: 1 / -1;
}

.content-info-additional {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
  background: rgb(234, 234, 234);
  border-radius: 5px;
  font-size: 13px;
  padding: 20px 30px;
  overflow: scroll;
  height: 50vh;
  text-align: start;
}

/* restrições */
.container-restriction {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: rgb(234, 234, 234);
  border-radius: 5px;
}

.content-general-states {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  height: 30vh;
  width: 100%;
}

.content-alvo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  height: 30vh;
  width: 100%;
  border: 1px solid rgb(214, 214, 214);
  border-right: none;
  border-left: none;
}

.content-culture-restriction {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  height: 30vh;
  width: 100%;
}

/* spinner */
.newtons-cradle {
  --uib-size: 50px;
  --uib-speed: 1.2s;
  --uib-color: #016011;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--uib-size);
  height: var(--uib-size);
}

.newtons-cradle__dot {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  width: 25%;
  transform-origin: center top;
}

.newtons-cradle__dot::after {
  content: "";
  display: block;
  width: 100%;
  height: 25%;
  border-radius: 50%;
  background-color: var(--uib-color);
}

.newtons-cradle__dot:first-child {
  animation: swing var(--uib-speed) linear infinite;
}

.newtons-cradle__dot:last-child {
  animation: swing2 var(--uib-speed) linear infinite;
}

@keyframes swing {
  0% {
    transform: rotate(0deg);
    animation-timing-function: ease-out;
  }

  25% {
    transform: rotate(70deg);
    animation-timing-function: ease-in;
  }

  50% {
    transform: rotate(0deg);
    animation-timing-function: linear;
  }
}

@keyframes swing2 {
  0% {
    transform: rotate(0deg);
    animation-timing-function: linear;
  }

  50% {
    transform: rotate(0deg);
    animation-timing-function: ease-out;
  }

  75% {
    transform: rotate(-70deg);
    animation-timing-function: ease-in;
  }
}

/* radio */
.container-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-radio {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.custom-radio input[type="radio"] {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.radio-circle {
  width: 15px;
  height: 15px;
  border: 2px solid #dddddd;
  border-radius: 50%;
  margin-right: 10px;
  transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}

.radio-text {
  font-size: 13px;
  color: #333;
  transition: color 0.3s ease-in-out;
}

.custom-radio input[type="radio"]:checked + .radio-label {
  background-color: #dddddd;
}

.custom-radio input[type="radio"]:checked + .radio-label .radio-circle {
  border-color: #fff;
  background-color: #606060;
}

.custom-radio input[type="radio"]:checked + .radio-label .radio-text {
  color: #64748b;
}
</style>
